import { CalendarEvent } from '@intelligent-play-v2/domain';
import { queryBuilder } from '~/api';

export const getNextPitchEvent = async (
  pitchId: number | string
): Promise<CalendarEvent | null> => {
  const { data } = await queryBuilder('GET', 'calendar/nextEvent', { pitchId });
  return data;
};
